import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const institutionItemTemplatesApi = {
    getInstitutionItemTemplates: (institutionId: number): Observable<Dtos.GetInstitutionItemTemplatesResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionItemTemplates = new Dtos.GetInstitutionItemTemplates();

        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.GetInstitutionItemTemplatesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getInstitutionItemTemplateById: (id: number): Observable<Dtos.GetInstitutionItemTemplateByIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionItemTemplateById = new Dtos.GetInstitutionItemTemplateById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetInstitutionItemTemplateByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setInstitutionItemTemplate: (institutionItemTemplate: Dtos.InstitutionItemTemplate, collection: Dtos.Collection): Observable<Dtos.SetInstitutionItemTemplateResponse> => {

        let request: Dtos.SetInstitutionItemTemplate = new Dtos.SetInstitutionItemTemplate();

        request.institutionItemTemplate = institutionItemTemplate;
        request.collection = collection;

        // send request
        const response: Promise<Dtos.SetInstitutionItemTemplateResponse> = client.post(request);

        return Observable.from(response);

    },
    createInstitutionItemTemplate: (institutionId: number): Observable<Dtos.CreateInstitutionItemTemplateResponse> => {
        //Create the request.
        let request: Dtos.CreateInstitutionItemTemplate = new Dtos.CreateInstitutionItemTemplate();

        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.CreateInstitutionItemTemplateResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateInstitutionItemTemplate: (institutionItemTemplate: Dtos.InstitutionItemTemplate, collection: Dtos.Collection): Observable<Dtos.ValidateInstitutionItemTemplateResponse> => {

        let request: Dtos.ValidateInstitutionItemTemplate = new Dtos.ValidateInstitutionItemTemplate();

        request.institutionItemTemplate = institutionItemTemplate;
        request.collection = collection;

        // send request
        const response: Promise<Dtos.ValidateInstitutionItemTemplateResponse> = client.post(request);

        return Observable.from(response);

    },
}